import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';

export const useCompleteTask = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();

  return useMutation({
    mutationFn: (taskId: number) =>
      api({
        route: `/private/dashboard/task/${taskId}/complete`,
        method: 'POST',
        token: userToken,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['provider-home-tasks'] }),
  });
};
